import React from 'react';
import MatchIcon from '../../../icons/MatchIcon';
import RatingIcon from '../../../icons/RatingIcon';
import NewsIcon from '../../../icons/NewsIcon';
import SettingsIcon from '../../../icons/SettingsIcon';
import DocumentsIcon from '../../../icons/DocumentsIcon';
import FeedbackIcon from '../../../icons/FeedbackIcon';

export const services = [
  {
    name: 'Home',
    value: 'home',
    description: '',
    icon: <MatchIcon/>
  },
  {
    name: 'Documents',
    value: 'documents',
    description: 'Easily store, categorise and search your NDIS-related documents.',
    icon: <DocumentsIcon/>,
  },
  {
    name: 'Service Requests',
    value: 'requests',
    description: 'Create and manage requests for new services.',
    icon: <MatchIcon/>
  },
  {
    name: 'My Reviews',
    value: 'my-reviews',
    description: 'View your service reviews and responses.',
    icon: <RatingIcon/>
  },
  {
    name: 'News',
    value: 'news',
    description: 'The latest disability news from across the web.',
    icon: <NewsIcon/>
  },
  {
    name: 'Settings',
    value: 'settings',
    description: 'Control your personal information and configuration.',
    icon: <SettingsIcon/>
  },
  {
    name: 'Feedback',
    value: 'feedback',
    description: 'Let us know what you would like to see on this platform',
    icon: <FeedbackIcon/>
  },
];
